import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";

import { Perfil } from "../../models/Perfil.model";
import { Validation } from "./validation";
import { NgxSpinnerService } from "ngx-spinner";
import { STORAGE_KEY_CURRENT_USER } from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import { PerfilTipo } from "src/app/models/PerfilTipo.model";

@Component({
  selector: "app-create-perfil",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class EditPerfilComponent implements OnInit {
  private apiBaseService: ApiBaseService;

  public perfilForm: FormGroup;
  public perfilTipoSelected;
  public perfil;
  public perfilId: number;
  public title = "Atualizar Perfil";
  public errorMessage;
  private validation: Validation;
  public types: any = [];
  public ngClassStepper = "stepper-click-enable";

  public pageSize = 10;

  ngOnInit(): void {
    this.perfilForm = this.formBuilder.group(this.validation.rules());
    this.perfilId = this.activatedRoute.snapshot.params["id"];
    this.loadPerfil(this.perfilId);
    this.setup();
  }

  async setup(): Promise<void> {
    try {
      this.spinner.show();

      var pageIndex = 0;

      const params = {
        size: this.pageSize,
        page: pageIndex,
      };
      const types = await this.apiBaseService.get<PerfilTipo>({
        url: new PerfilTipo()["nomeConsultaApiBase"],
        params,
      });
      this.types = types["content"];

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }

  public async loadPerfil(id): Promise<void> {
    try {
      this.spinner.show();

      const response = await this.apiBaseService.get<Perfil>({
        url: new Perfil()["nomeConsultaApiBase"] + "/" + id,
      });

      this.perfil = response as Perfil;
      this.fillUserData();

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }
  constructor(
    apiBaseService: ApiBaseService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute
  ) {
    this.apiBaseService = apiBaseService;
    this.validation = new Validation();
  }
  fillUserData(): void {
    this.perfilTipoSelected = this.perfil.perfilTipo.id;

    if (this.perfilTipoSelected) {
      this.perfilForm.controls["perfilTipo"].setValue(this.perfilTipoSelected);
    }

    const fields = ["nmPerfil", "dsPerfil"];
    fields.forEach((element) => {
      this.perfilForm.controls[element].setValue(this.perfil[element]);
    });
  }

  public async submitForm(stepper?): Promise<void> {
    try {
      this.spinner.show();
      this.coverterUpperCase(this.perfilForm);

      const values = this.perfilForm.value;
      const id = Math.floor(this.perfilId);
      const post = {
        id,
        ...values,
        perfilTipo: { id: parseInt(values.perfilTipo) },
        idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      };

      await this.apiBaseService.put<Perfil>(
        this.perfilId,
        new Perfil()["nomeConsultaApiBase"],
        post
      );

      this.spinner.hide();

      this.router.navigate(["/perfil"]);
    } catch (error) {
      this.spinner.hide();
      this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public coverterUpperCase(perfilForm: FormGroup) {
    if (perfilForm.get("nmPerfil").value != null) {
      perfilForm
        .get("nmPerfil")
        .setValue(perfilForm.get("nmPerfil").value.toUpperCase());
    }

    if (perfilForm.get("dsPerfil").value != null) {
      perfilForm
        .get("dsPerfil")
        .setValue(perfilForm.get("dsPerfil").value.toUpperCase());
    }
  }
}
